import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import LogoQuizAppBar from './logo-quiz-app-bar';
import {GAME_SCREEN, getScreenTitleKey, LOGIN_EMAIL_SCREEN, LOGOS_SCREEN} from "../../ducks/duck-screen";
import {getTranslation} from "../../helpers/get-translation";

function LogoQuizAppBarContainer(props) {
	const { goBack, currentScreen, activeLogo, hintCount, currentLevel, collectedRiddlesAll, loginAction } = props;

	function getTitle(screen){
		const titleKey = getScreenTitleKey(screen);

		switch(screen){
			case LOGOS_SCREEN: {
				if(currentLevel && currentLevel.levelOrder){
					return getTranslation(titleKey, [currentLevel.levelOrder])
				} else {
					return ""
				}
			}
			case LOGIN_EMAIL_SCREEN:{
				const key = getScreenTitleKey(loginAction);
				return getTranslation(key)
			}
			default: {
				return getTranslation(titleKey)
			}
		}
	}

	const appBarProps = {
		collectedRiddlesAll,
		hintCount,
		currentScreen
	};


	if(currentScreen === GAME_SCREEN){
		let StarsImage;
		if(activeLogo.points > 0 && !activeLogo.answer){
			StarsImage = props => (<img src={"static/images/logo-screen/grid_item_complete_bg_" + activeLogo.points + ".png"}/>)
		} else {
			StarsImage = props => (<span/>)
		}
		return (
			<LogoQuizAppBar {...appBarProps} onClick={() => (goBack())}  StarsImage={StarsImage}/>
		)
	} else {
		const title = getTitle(currentScreen);

		return (
			<LogoQuizAppBar {...appBarProps} title={title} onClick={() => (goBack())} />
		)
	}
}

LogoQuizAppBarContainer.propTypes = {
	currentScreen: PropTypes.string.isRequired,
	loginAction: PropTypes.string.isRequired,
	title: PropTypes.string,
	goBack: PropTypes.func.isRequired,
	activeLogo: PropTypes.object.isRequired,
	currentLevel: PropTypes.object,
	hintCount: PropTypes.number,
	collectedRiddlesAll: PropTypes.number
};

function mapStateToProps(state) {
	return {
		activeLogo: state.screenReducer.activeLogo,
		loginAction: state.userReducer.loginAction,
		hintCount: state.userReducer.user.hintCount,
		collectedRiddlesAll: state.userReducer.stats.collectedRiddlesAll,
		currentLevel: state.gameReducer.currentLevel
	};
}

export default connect(mapStateToProps)(LogoQuizAppBarContainer);
